import axios from 'axios'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'

export default class JiminnyPhone {
  static call (params) {
    return axios.post(`${jiminnyHost()}/api/v1/activity/softphone/dial`, params, {
      headers: {
        'X-Jiminny-Device-Id': store.get('deviceId')
      }
    })
  }
  static disconnect (activityId) {
    return axios.delete(`${jiminnyHost()}/api/v1/activity/softphone/${activityId}`, {
      headers: {
        'X-Jiminny-Device-Id': store.get('deviceId')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/rep-call/jiminny-softphone/jiminny-phone.js